import { useState } from "react";
import {
  FilterButton,
  TabButtonGroup,
} from "../components/shared";
import {
  buttonLabelKnowledgeBase,
  featuredArticles,
} from "../utils/data";

const KnowledgeBase = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="flex flex-row   min-h-[calc(100vh-100px)]">
      <div className="flex flex-col w-full h-auto gap-3 lg:gap-3 ">
        <div className="w-full justify-between h-[22px] border-b pr-1 border-[#0000002B] flex items-center">
          <h1 className="h-[24px] text-[13px] font-semibold leading-[100%] text-black font-inter">
            Knowledge Base{" "}
          </h1>
        </div>
        <div className="flex flex-row items-center justify-between w-full ">
          <div className="flex flex-row items-center justify-between w-full pr-2">
            <div className="w-full h-[40px] rounded-[12px] bg-white shadow-[4px_4px_20px_0px_#00000040] flex items-center pl-4 justify-between">
              <input
                type="text"
                placeholder="Search the knowledge base..."
                className="w-full bg-transparent text-[12px] font-inter font-normal text-[#00000096] 
                placeholder:text-[12px] placeholder:text-[#00000096] outline-none text-opacity-40"
              />
              <FilterButton
                icon="/icons/search2.png"
                onClick={() => console.log("Filter clicked")}
                label="Search"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-row items-center justify-between w-full">
          <div className="flex flex-row items-center w-full gap-x-2">
            <FilterButton
              label="All Content"
              buttonClassName="bg-white shadow-[4px_4px_20px_0px_#00000040]"
            />
            <FilterButton
              label="Articles"
              showIcon={false}
              buttonClassName="bg-white shadow-[4px_4px_20px_0px_#00000040]"
            />
            <FilterButton
              label="Faqs"
              showIcon={false}
              buttonClassName="bg-white shadow-[4px_4px_20px_0px_#00000040]"
            />
            <FilterButton
              label="Tutorials"
              showIcon={false}
              buttonClassName="bg-white shadow-[4px_4px_20px_0px_#00000040]"
            />
            <FilterButton
              label="Troubleshooting"
              showIcon={false}
              buttonClassName="bg-white shadow-[4px_4px_20px_0px_#00000040]"
            />
          </div>
        </div>
        <div className="w-full px-2 mt-4">
          <TabButtonGroup
            buttonLabels={buttonLabelKnowledgeBase}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            gapClass="gap-x-16" // Custom gap
          />{" "}
        </div>
        {/* Chat List View */}
        <h1 className="h-[13px] text-start px-2 mt-2 text-[13px] leading-[100%] text-black  font-inter">
          Featured Articles
        </h1>

        <div className="grid grid-cols-1 gap-4 pr-2 mt-2 md:grid-cols-2 lg:grid-cols-3">
          {featuredArticles.map((article) => (
            <div
              key={article.id}
              className="bg-white shadow-[2px_2px_20px_0px_#00000040] rounded-[12px] overflow-hidden flex flex-col"
            >
              <img
                src={article.image}
                alt={article.title}
                className="w-[323px] h-[200px] object-cover rounded-[12px]"
              />

              <div className="flex flex-col gap-2 p-3">
                <div className="flex flex-row items-center justify-between">
                  <div className="flex flex-row items-center gap-1 bg-[#FFE3E3] rounded-lg">
                    <span className="text-[10px] font-inter px-2 text-[#FF1F1F]">
                      {article.priority}
                    </span>
                  </div>
                  <span className="text-[10px] font-inter text-[#00000073]">
                    {article.readTime}
                  </span>
                </div>

                <span className="font-inter font-medium text-[13px] leading-[100%] tracking-[-3%] text-black">
                  {article.title}
                </span>
                <span className="text-[12px] font-inter text-[#00000073] text-opacity-80">
                  {article.description}
                </span>

                <div className="flex flex-row items-start justify-between w-full pb-2 ">
                  <div className="flex flex-row">
                    <img
                      src={article.author.avatar}
                      alt="icon"
                      className="w-[40px] h-[40px]  object-scale-down"
                    />
                    <div className="flex flex-col w-full pl-2 mt-1">
                      <span className="text-[12px] font-inter font-semibold text-black">
                        {article.author.name}
                      </span>
                      <span className="text-[11px] font-inter text-[#00000073] text-opacity-80">
                        {article.author.role}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel */}
      <div className="border-[#0000002B]  w-[26%] border-l">
        {/* <SelectedMention /> */}
      </div>
    </div>
  );
};

export default KnowledgeBase;
